import { render, staticRenderFns } from "./PageSearchResult.vue?vue&type=template&id=da6bac36&scoped=true&"
import script from "./PageSearchResult.vue?vue&type=script&lang=js&"
export * from "./PageSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./PageSearchResult.vue?vue&type=style&index=0&id=da6bac36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6bac36",
  null
  
)

export default component.exports